module.exports = __webpack_public_path__ + "img/CM-SL-24-Nissan-Playful.6334f9dc.jpg";